{
  "audit_date": "May 1, 2026",
  "display_name": "Andre",
  "estate_url": "https://dev.hearthfire.ai/estate",
  "flagged_count": "2",
  "household_name": "Andre's household",
  "summary": "• Roth IRA at Fidelity — no contingent beneficiary set\n• Term life policy with Haven — primary beneficiary unchanged since 2018",
  "total_examined": "14"
}
